<template>
    <b-row>
        <b-col cols="12" class="mb-4">
            <div class="intranet-nav-content">
                <div v-if="programSeasonLoading">
                    <pulse-loader
                        :color="'#fff'"
                        :margin="'10px'"
                        :size="5">
                    </pulse-loader>
                </div>

                <div v-else>
                    <intranet-nav-content-link-exact
                        :link="{
                            name: `${programSeason.program_name} - ${programSeason.season_name}`,
                            path: { 
                                name: 'admin-program-season-details',
                                params : { 'IdProgramSeason' : programSeason.id }
                            } 
                        }">
                    </intranet-nav-content-link-exact>

                    <intranet-nav-content-link
                        :link="{name: 'Sponsors', path: {name: 'admin-program-sponsors-list' }}">
                    </intranet-nav-content-link>
                </div>
            </div>
        </b-col>

        <b-col>
            <slide-y-down-transition :duration="350" origin="center top" mode="out-in">
                <router-view></router-view>
            </slide-y-down-transition>
        </b-col>
    </b-row>

</template>

<script>
import { getProgramSeason } from '@/api/ProgramSeason/ProgramSeason'
import IntranetNavContentLinkExact from '@/layout/NavContent/IntranetNavContentLinkExact';
import IntranetNavContentLink from '@/layout/NavContent/IntranetNavContentLink';
import { SlideYDownTransition  } from 'vue2-transitions';

export default {
    name: 'ProgramSeason',
    components: { 
        IntranetNavContentLink,
        IntranetNavContentLinkExact,
        SlideYDownTransition,
    },
    data: () => ({
        programSeason: {},
        programSeasonLoading: false
    }),
    created () {
        this.getData()
    },
    methods: {
        getData () {
            this.programSeasonLoading = true

            let IdProgramSeason = this.$route.params.IdProgramSeason

            getProgramSeason(IdProgramSeason)
                .then(({data}) => {
                    this.programSeason = data.data.attributes
                })
                .catch(err => {
                    console.log('get-programSeason err', err);
                })
                .finally(() => {
                    this.programSeasonLoading = false
                    console.log('request get-programSeason end');
                })
        }
    }
};
</script>